module.exports = "<app-room-list></app-room-list>\r\n"